<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                Material Requisition - View
                <div class="card-header-actions">
                    <button  class="btn btn-primary mr-1" @click="print()"><i class="fa fa-print"></i> Print</button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
              <b-row>
                <b-col lg="8">
                    <b-row>
                        <b-col lg="6" xl="5">
                        <b-input-group>
                            <b-input-group-prepend><label>Request Number</label></b-input-group-prepend>
                            <b-form-input v-model="model.requestno" readonly></b-form-input>
                        </b-input-group>
                        </b-col>
                        <b-col lg="6" xl="5">                            
                        <b-input-group>
                            <b-input-group-append><span class="input-group-text">Request Date</span></b-input-group-append>
                            <b-form-input v-model="model.requestdate" type="date" disabled></b-form-input>                                        
                        </b-input-group>
                        </b-col>
                    </b-row >    
                    <b-row>
                        <b-col lg="6" xl="5">                            
                            <b-input-group >
                            <b-input-group-prepend><label>Request Type</label></b-input-group-prepend>
                                <b-form-input :value="model.jasa?'Service Request':'Material Request'" readonly></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col lg="6">                            
                            <b-input-group>
                                <b-input-group-prepend><label>Internal Budget No.</label></b-input-group-prepend>
                                <b-form-input v-model="model.budgetinfo" readonly v-b-tooltip.hover :title="model.budgetname"></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row >    
                    <b-row align-h="between">
                        <b-col lg="6" xl="5">                            
                            <b-input-group >
                                <b-input-group-prepend><label>{{labelExpected}}</label></b-input-group-prepend>
                                <b-form-input v-model="model.expectreceipt" type="date" disabled></b-form-input>                                        
                            </b-input-group>
                        </b-col>
                        <b-col lg="6" xl="5">                            
                            <b-input-group v-show="(model.jasa)">
                                <b-input-group-prepend><label>Expect.Service Finish</label></b-input-group-prepend>
                                <b-form-input v-model="model.jasafinish" type="date" disabled></b-form-input>                                        
                            </b-input-group>
                        </b-col>
                    </b-row>                      
                    <b-input-group >
                        <b-input-group-prepend><label>{{labelLocation}}</label></b-input-group-prepend>
                        <b-form-input v-model="model.locationdeliv"  disabled></b-form-input>
                    </b-input-group>
                    <b-input-group >
                        <b-input-group-prepend><label>Note/Remark</label></b-input-group-prepend>
                        <b-form-input v-model="model.remark" disabled></b-form-input>
                        <b-form-checkbox :value="1" :unchecked-value="0" v-model="model.barter" class="mt-1" disabled>BARTER</b-form-checkbox>
                    </b-input-group>
                </b-col>
                <b-col md="4">
                    <v-dim :model="model" :key="updateDimHdr" ></v-dim>
                </b-col>
              </b-row>
              <b-card no-body class="mb-1">
                <b-table
                    class="mb-0"
                    ref="tblReqLines"
                    outlined
                    striped hover small
                    style="font-size:smaller;"
                    :items="reqLines.items"
                    :fields="reqLines.fields"
                    :current-page="reqLines.page"
                    :per-page="reqLines.limit"
                    >
                        <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                        </template>
                        <template v-slot:cell(partnumber)="data">
                            {{data.item.partnumber}} | {{data.item.itemname}}
                        </template>
                        <template v-slot:cell(quantity)="data">
                            {{data.item.quantity}} {{data.item.invunitom}}
                        </template>
                        <template v-slot:cell(action)="data">
                            <div class="text-center">
                            <a href="javascript:void(0)" @click="editReqLines(data.item,data.toggleDetails)">
                                <i class="fa fa-pencil"></i>
                            </a>
                            |
                            <a href="javascript:void(0)" class="text-danger" @click="delReqLines(data.index)">
                                <i class="fa fa-trash"></i>
                            </a>
                            </div>
                        </template>
                    <template v-slot:row-details="row">
                    <b-card class="row-details-form">
                      <b-row  align-h="center">
                        <b-col lg="6" xl="6">
                            <b-input-group>
                                <b-input-group-prepend><label>Master Item</label></b-input-group-prepend>
                                <b-form-input readonly v-model="reqLinesObj.iteminfo"></b-form-input>
                            </b-input-group>
                            <b-input-group>
                                <b-input-group-prepend><label>Specs/Descript.</label></b-input-group-prepend>
                                <b-form-textarea :rows="3" :max-rows="10" v-model="reqLinesObj.description" disabled ></b-form-textarea>
                            </b-input-group>
                            <b-form-row>
                              <b-col md="6">                            
                                <b-input-group>
                                    <b-input-group-prepend><label>Quantity</label></b-input-group-prepend>
                                    <b-form-input v-model="reqLinesObj.quantity" type="number" disabled></b-form-input>
                                </b-input-group>
                              </b-col>
                              <b-col md="6">                            
                                <b-input-group>
                                    <b-input-group-prepend><label style="width:70px; text-align:right;">Unit Size</label></b-input-group-prepend>
                                    <b-form-input v-model="reqLinesObj.invunitom" disabled></b-form-input>
                                </b-input-group>
                              </b-col>
                            </b-form-row >     
                        </b-col>
                        <b-col lg="6" xl="5">
                            <v-dim :model="reqLinesObj" :key="updateDimDtl" ></v-dim>
                        </b-col>
                      </b-row>
                      <b-row class="justify-content-center mt-1">
                        <div style="width:400px;">
                            <b-input-group >
                                <b-input-group-append>
                                    <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Hide Detail</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </div>
                      </b-row>
                    </b-card>
                    </template>                        
                </b-table>
                <b-row class="mt-1">
                    <b-col cols="6">
                        <b-row>
                            <div class="ml-3">
                                Showing {{((reqLines.page - 1) * reqLines.limit + 1)}}
                                to <span v-if="((reqLines.page * reqLines.limit)>reqLines.total)">{{reqLines.total}}</span>
                                    <span v-else>{{reqLines.page * reqLines.limit}}</span>
                                <strong> of {{reqLines.total}} entries </strong>
                            </div>    

                        </b-row>                    
                    </b-col>
                    <b-col cols="6">
                        <b-input-group>
                            <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
                            <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px; !important;"></b-form-input>  
                            <b-pagination
                                :total-rows="reqLines.total"
                                :per-page="reqLines.limit"
                                v-model="reqLines.page"
                            ></b-pagination>
                        </b-input-group>
                    </b-col>
                </b-row>
              </b-card>    
            <b-row class="justify-content-center mb-2">
                <button  class="btn btn-primary mr-1" @click="print()"><i class="fa fa-print"></i> Print</button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
            </b-row>

        </b-card>

        <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
            <iframe v-if="reportUrl" :src="reportUrl" frameborder="0"></iframe>
        </b-modal>

    </div>
</template>
<style lang="scss">

    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 80px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>

<script>
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../components/my-number";
import vDim from "./lookup/dim";
import mr from "../apis/logistic_mr";
toastr.init();

export default {   
  components: { myNumber, vDim},
  data() {
    return {
        saveEnabled:true,
      inputBerlanjut: 0,
      inputLineBerlanjut: 1,
      showReport:false,
      reportUrl: null,
        updateDimHdr:false,
        updateDimDtl:true,
        uanguser: this.$store.state.user.matauang,
        dimension:this.$store.state.dimension,
        linetypes : [{ value: 1, text: 'Master Item ' },{ value: 3, text: 'GL Account' }],
        jasaMaterial : [{ value: 1, text: 'Service Request' }, { value: 0, text: 'Material Request' }],
        itemList:{},
        labelLocation:'Delivery Location',
        labelExpected:'Expected Delivery',
        limit:20,
        reqLines: {
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "partnumber",
                    label: "Master Item",
                    thStyle: "width:240px",
                },
                {
                    key: "description",
                    label: "Description",
                    thStyle: "width:240px",
                },
                {
                    key: "quantity",
                    label: "Quantity",
                    thStyle: "width:100px",
                    thClass: "text-center",
                    tdClass: "text-center"
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:40px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 20,
            total: 0,
        },
        model: {
            jasa: 0,
            requestdate: '',
            expectreceipt: '',
            jasafinish: '',
            remark: '',
            matauang: this.$store.state.user.matauang, requestno:'',
            locationdeliv: this.$store.state.user.compaddr
        },
        reqLinesObj: {
            linetype:1,
            itemno: '', invunitom:'',
            description: '',
            quantity: 0
        },

    };
},
  watch: {
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.reqLines.limit=newVal;
        }
      }, 500);
    },    

  },
  created: async function(){
      console.log('params: ', this.$route.params);
    if (this.$route.params.requestkey)  {
          toastr.info('Loading Request Detail, please wait')
          try {
            const data = await mr.detail(this.$route.params);  
            const row = data[0][0];
            row.requestdate = row.requestdate ? moment(row.requestdate).format('YYYY-MM-DD') : '';
            row.expectreceipt = row.expectreceipt ? moment(row.expectreceipt).format('YYYY-MM-DD') : '';
            for (var key in row) {
                this.model[key] = row[key];
            }
            this.reqLines.items = data[1];
            this.inputBerlanjut=0;
            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
      } else {
        this.model.requestdate = moment().format('YYYY-MM-DD');  
          const { cart } = this.$store.state;
          if (cart.items.length>0)
          {
              cart.items.forEach((item) =>{
                const ada = this.reqLines.items.find(i=> i.partnumber===item.code);
                if (ada) {
                    ada.quantity+=1;
                } else {
                    this.reqLines.items.push(
                        { linetype:1,
                          itemno: item.itemno,
                            partnumber: item.partnumber,
                        itemname:item.itemname, 
                        iteminfo:item.partnumber+ '|' +item.itemname,
                        description:'-',
                        quantity:1, 
                        invunitom: item.invunitom || 'PCS'});
                }
              })
            this.reqLines.total=this.reqLines.items.length;
            this.$store.state.carts.items=[];
            localStorage.removeItem('cart');
          }
          this.model.requestdate = moment().format('YYYY-MM-DD');

      }
        this.reqLines.total=this.reqLines.items.length;
  },
  methods: {
    print: async function()
    {
      if (this.model.requestkey) {
          try {
                this.showReport=true;
              this.reportUrl= await mr.print(this.model);
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    closeReqLines: function(){
        const opened= this.reqLines.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    editReqLines : function (obj,callback) {
        this.closeReqLines();
        this.reqLines.selected = obj;
        for (var key in this.reqLinesObj) {
            this.reqLinesObj[key] = '';
        }
        for (var key in obj) {
            this.reqLinesObj[key] = obj[key];
        }
        this.dimension.forEach((dim) => {
            if (obj[dim.value]) {
                this.reqLinesObj[dim.value] = obj[dim.value];
                this.reqLinesObj[`${dim.value}Txt`] = obj[`${dim.value}Txt`];
                this.reqLinesObj[`${dim.value}Info`] = obj[dim.value] + ' | '+ obj[`${dim.value}Txt`];
            }
        });
        callback();
    },    
    close(){
      if ((this.$store.state.prevRoute.name)) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
          router.push({name:"app.modules"});
      }
    }
  }
};
</script>
